module.exports = __webpack_public_path__ + "static/media/1_WEB_SIVI_Vue-ext.817dae5e.jpg";